<template>
  <!-- 网媒管理系统产品介绍 -->
  <div class="wm-introduction-box border_box">
    <img :src="imginfo" alt="">
  </div>
</template>
<script>
export default {
  name:'wmIntroduction',
  data(){
    return {
      imginfo: require('../../assets/images/wmSet/wm-introduction.png')
    }
  },
  created(){
    // 产品介绍页面，更改网页ico
    let pageUrl = this.$route.path
    if(pageUrl === '/wmintroduction'){
      document.querySelector("link.linkico").href = "./wmico.ico";
    }else{
      document.querySelector("link.linkico").href = "./favicon.ico";
    }
  },
  computed: {
   
  },
  mounted(){
    
  },
  methods:{
  }
}
</script>

<style scoped>
.wm-introduction-box img {
  display: block;
  border: none;
  width: 100%;
}
</style>